import React from "react";
import VideoPlayer from "pages/video-hub";
import LoginPopup from "components/login-popup";

function SharedVideoHub() {
  return (
    <>
      <VideoPlayer isPublic={true} />
      <LoginPopup isPublic={true} />
    </>
  );
}

export default SharedVideoHub;
